import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";



let redux = reduxCreator.type('USER_IP').plugin(axiosPlugin, {template: "array"});

let fetchUserAction = redux.fetchActionCreate();


export const fetchUserByIp = (data = {}) => fetchUserAction(`/users/find-ip`, data);
export const resetUserByIp = () => redux.actions.reset();

export const userByIp = redux.reducer();